module.exports = __webpack_public_path__ + "static/img/on10.44990063.png";